import _ from '../../common/utility';

function bucketsMenu() {
    if (!(_.isCOE() && $('.coe-v2').length)) return;

    let listItems = document.querySelectorAll('.hp_resource-center>ul li a');
    listItems.forEach(function (ele, i) {
        let trackValue = $(ele).attr('name');
        let targetEle = $(`.page-body section[data-track=${trackValue}]`);

        if (targetEle.length == 0) {
            // $(ele).parent().addClass('inactive');
            $(ele).parent().remove();
        }
    })

    $('.hp_resource-center>ul a').on('click', function (e) {
        let trackValue = $(e.target).attr('name');
        let targetEle = $(`.page-body section[data-track=${trackValue}]`);
        if (targetEle.length > 0 && trackValue) {
            wmdPageLink(trackValue, this);
            targetEle[0].scrollIntoView();
        }
    })
    $('.hp_resource-center>ul').flickity({
        cellAlign: 'left',
        groupCells: true,
        pageDots: false
    });
}

export default _.catch(bucketsMenu);